// 
export const ADDRESS_LIST = 'ADDRESS_LIST';
export const ADDRESS_PAGINATION = 'ADDRESS_PAGINATION';